var map = {
	"./pin_agenzie.png": 9636,
	"./pin_agenzie_disable.png": 1025,
	"./pin_agenzie_highlighted.png": 3442,
	"./pin_autosicura.png": 5673,
	"./pin_autosicura_highlighted.png": 8459,
	"./pin_ballsystem.png": 5311,
	"./pin_ballsystem_highlighted.png": 7717,
	"./pin_blue.png": 3567,
	"./pin_blue_highlighted.png": 9925,
	"./pin_brown.png": 9575,
	"./pin_brown_highlighted.png": 829,
	"./pin_carclinic.png": 8577,
	"./pin_carclinic_highlighted.png": 4227,
	"./pin_carglass.png": 6109,
	"./pin_carglass_highlighted.png": 3607,
	"./pin_convenzionate_axa.png": 779,
	"./pin_convenzionate_axa_highlighted.png": 1481,
	"./pin_dottor_grandine.png": 4312,
	"./pin_dottor_grandine_highlighted.png": 7982,
	"./pin_eurograndine.png": 1732,
	"./pin_eurograndine_highlighted.png": 7586,
	"./pin_glassdrive.png": 4247,
	"./pin_glassdrive_highlighted.png": 1373,
	"./pin_hailguard.png": 526,
	"./pin_hailguard_highlighted.png": 1344,
	"./pin_inova.png": 6368,
	"./pin_inova_highlighted.png": 2326,
	"./pin_locator_blue.svg": 4456,
	"./pin_maestri.png": 2746,
	"./pin_maestri_highlighted.png": 1316,
	"./pin_mps.png": 6533,
	"./pin_mps_highlighted.png": 8719,
	"./pin_nonsolograndine.png": 6491,
	"./pin_nonsolograndine_highlighted.png": 9510,
	"./pin_odontoiatria.png": 4236,
	"./pin_odontoiatria_highlighted.png": 6618,
	"./pin_odontoiatria_highlighted_old.png": 712,
	"./pin_odontoiatria_old.png": 7018,
	"./pin_protezione_salute.png": 4379,
	"./pin_protezione_salute_highlighted.png": 2249,
	"./pin_red.png": 8366,
	"./pin_red_highlighted.png": 64,
	"./pin_riparte.png": 322,
	"./pin_riparte_highlighted.png": 2412,
	"./pin_route_end.png": 8058,
	"./pin_route_start.png": 8601,
	"./pin_semplicemente_vita.png": 4223,
	"./pin_semplicemente_vita_highlighted.png": 6581,
	"./pin_sos_grandine.png": 7811,
	"./pin_sos_grandine_highlighted.png": 5505,
	"./pin_specialistici_convenzionati.png": 1711,
	"./pin_specialistici_convenzionati_highlighted.png": 117,
	"./pin_specialistici_convenzionati_highlighted_old.png": 2064,
	"./pin_specialistici_convenzionati_old.png": 197,
	"./pin_stormsolution.png": 901,
	"./pin_stormsolution_highlighted.png": 4575,
	"./pin_subagenzie.png": 8966,
	"./pin_subagenzie_disable.png": 7263,
	"./pin_subagenzie_highlighted.png": 808,
	"./pin_upgrandine.png": 4872,
	"./pin_upgrandine_highlighted.png": 8846,
	"./pin_vetrocar.png": 7213,
	"./pin_vetrocar_highlighted.png": 4599,
	"./pin_yellow.png": 1643,
	"./pin_yellow_highlighted.png": 4345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7859;